import SmartbannerValueObject from './SmartbannerValueObject.js'

export default class SmartbannerValueObjectsFactory {
  static smartbannerValueObject = ({buttonUrl, iconUrl, showSmartbanner, ratingValue}) =>
    new SmartbannerValueObject({
      buttonUrl,
      iconUrl,
      showSmartbanner,
      ratingValue
    })
}
